// extracted by mini-css-extract-plugin
export default {"detail":"UserForm_detail__ZVqxs","delete":"UserForm_delete__jlBxI"};